import { useEffect, useRef } from 'react';

export const useMemorySafeTimeout: () => (
  cb: () => void,
  ms: number
) => void = () => {
  const timoutId = useRef<NodeJS.Timeout>();

  const setSafeTimeout: (cb: () => void, ms: number) => void = (cb, ms) => {
    timoutId.current = setTimeout(cb, ms);
  };

  useEffect(() => {
    return () => {
      if (!timoutId) return;
      clearTimeout(timoutId.current);
    };
  }, []);

  return setSafeTimeout;
};
